<div class="announcement-bar">
  <div class="announcement-bar__text body-emphasized-xs">
    <span class="message">{{ announcement.message }}</span>
    <a class="link" [href]="announcement.link" target="_blank">{{ announcement.linkText }}</a>
  </div>
  <ion-button size="small" fill="clear" color="light" (click)="dismiss()">
    <ion-icon name="close" slot="icon-only"></ion-icon>
  </ion-button>
</div>
